export default "__VITE_PUBLIC_ASSET__85d41623__"